import Navbar from "./components/Navbar";
import Home from '../src/screens/Home';
import Menu from "./screens/Menu";
import Book from "./screens/Book";
import React from "react";
import { Routes, Route } from "react-router-dom";


export default function App() {
  return (
    <div>
      <Navbar />
      {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/Menu" element={<Menu/>}/>
        <Route path="/Book" element={<Book/>}/>
      </Routes>
    </div>
  );
}
